import { createFileRoute, redirect } from '@tanstack/react-router'
import { PreferencesLegacyIframe } from '@admin/preferences/PreferencesLegacyIframe'

export const Route = createFileRoute('/_auth/preferences/modelSetting')({
  component: RouteComponent,
  beforeLoad: ({ context: { scopedEnablements } }) => {
    if (!scopedEnablements.global().hasStandardEnablement('Model', 'ADMIN')) {
      throw redirect({
        to: '/403',
        replace: true,
      })
    }
  },
})

function RouteComponent() {
  return <PreferencesLegacyIframe name="modelSetting" />
}
